
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import GroupIcon from '@material-ui/icons/Group';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import ExpandMore from '@material-ui/icons/ExpandMore';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CloseIcon from '@material-ui/icons/Close';
import InputIcon from '@material-ui/icons/Input';
import LanguageIcon from '@material-ui/icons/Language';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

import { userHandler } from '../platforms/UserHandler'

import { languageManager } from '../utils/languageManager'
import { COLOR,LANGUAGES } from '../App/constants';
import {platformHandler} from '../platforms/PlatformHandler'
import {flipwitFirebaseConnector} from '../platforms/flipwitFirebaseConnector'

import { connect }  from 'react-redux';

import { setPresentationModeConfig } from '../App/actions'

const drawerWidth = 300;
const drawerHeight = 440;

const styles = theme => ({
  root: {    
    height: 64,
  },
  appFrame: {
    height: 65,
    zIndex: 2,
    overflow: 'hidden',
    //position: 'fixed',
    position: 'absolute',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  'appBarShift-left': {
    marginLeft: drawerWidth,
  },
  'appBarShift-right': {
    marginRight: drawerWidth,
  },
  subMenuBackButton: {
    height: 48,
    marginLeft: 6,
  },
  subMenuButton: {
    //marginLeft: 0,
    //marginRight: 20,
    height: 64,
    padding: 0,
    overflow: 'visible',
    display: 'flex',
    //alignSelf: 'self-start',
    marginLeft: 'auto',
  },
  menuButton: {
    marginLeft: 0,
    marginRight: 20,
    padding:0,
    height: 64,
    overflow: 'visible',
    display: 'flex',
    alignSelf: 'self-start',
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
    height: drawerHeight,
  },
  drawerHeader: {
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 16px',
    ...theme.mixins.toolbar,
  },
  toolBar: {
    position:'absolute',
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    width: '100%',
    height: "64px",
    //height: '30px',
    //minHeight: '30px',
  },
  title: {
    fontSize: '1.1em',
    fontFamily: 'Roboto-Medium',
    fontWeight: 400,
  },    
  iconSubMenuBar: {
    height: '64px',
    width: '48px',
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    //borderRadius: '0px 0px 0px 15px',
    //borderBottom: '2px solid #EEEEEE',
    position: 'relative',
  },
  iconMenuBar: {
    height: '64px',
    width: '48px',
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    position: 'relative',
    //borderRadius: '0px 0px 15px 0px',
    //borderBottom: '2px solid #EEEEEE',
  },
  arrowMenu: {
   '-webkit-transition': 'all 0.3s ease',
   '-moz-transition': 'all 0.3s ease',
   '-o-transition': 'all 0.3s ease',
   '-ms-transition': 'all 0.3s ease',
   transition: 'all 0.3s ease',
  },       
  rotate90: {
    '-webkit-transform': 'rotate(180deg)',
    '-ms-transform': 'rotate(180deg)',
    transform: 'rotate(-180deg)',
  },
  menuCloseIcon: {
    color: 'white',
    height: 48,
  },
  userLabel: {
    marginRight:'auto', 
    color:'white',
    fontSize: '1em',
    fontWeight: 400,
  },
  menuItemCheck: {
    justifyContent: 'space-between',    
  },
  subMenuIcon: {
    color: COLOR.FLIPWIT_COLOR_1,
    marginRight: '6px',
  },
  badgeVotes: {
    marginRight: "-20px",
    marginTop: "9px",
    color: "white",
    fontFamily: 'Roboto-Regular',
    fontWeight: 700,
  },
  badgeVotesSubMenu: {
    color: "#FF5722",
    marginTop: "12px",
    fontFamily: "Roboto-Regular",
    fontWeight: "700",
    marginRight: "38px",
    border: "solid 2px",
    backgroundColor: "white",
  },
  divSubMenu: {
    display: "flex",
    width: "48px",
    position: "absolute",
    right: "0px",
  },
});


class MenuFlipwit extends React.Component {

  state = {
    open: false,    
    openLang: false,
    selectedLang: 'es',
    subMenu: null,    
  };

  componentDidMount() { 
    this.setState({selectedLang:this.context.store.getState().containers.appReducer.language})      
  }

  handleClick = () => {
    this.setState(state => ({ openLang: !state.openLang }));
  };

  handleLangChange = event => {
    languageManager.changeLanguage( event.target.value, this.setLanguage );
    this.setState({ selectedLang: event.target.value });    
  };

  clickOnSubMenuIcon = event => {
    
    console.log('Click en sub con',platformHandler.tutorial_start_second_part,platformHandler.presentationModeScreen);
    //Si esta en el tutorial en la parte del mobile
    if(platformHandler.tutorial_start_second_part) {
      if(platformHandler.presentationModeScreen) platformHandler.presentationModeScreen.finishStartTutorial();
    }

    this.setState({ subMenu: event.currentTarget });
    console.log('click',event.currentTarget)
  }

  handleSubMenuClose = () => {
    this.setState({ subMenu: null });
  };

  clickOnDrawerIcon = () => {

    //Si es el botón de abrir el menú, lo abre
    if(this.context.store.getState().containers.appReducer.showMenu) {
      this.setState({ open: true });
    }
    //Si no es porque es el de atras
    else {
      platformHandler.backPressed();
    }
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  setLanguage = ( jsonData ) => {
    platformHandler.setLanguage( jsonData );
    platformHandler.checkTitleBarScene( platformHandler.currentScene, false );
    this.forceUpdate();    
  }
  
  changePresentation = () => {
    this.handleSubMenuClose();
    this.handleDrawerClose();

    //Si estoy en la panllata de SlideEditor, regresa a la de seleccionar persentación.
    if(platformHandler.sceneManager.getCurrentScene()==="SlideEditor") {
      platformHandler.openScene("SelectPresentation");
    }
    else {
      platformHandler.sendCommandToPresentationModeScreen( {command: "closePresentation"} );
    }

    //Inserte envio de correo con preguntas acá
    /*platformHandler.closeCurrentSession();
    //this.changeScene('SelectPresentation');
    platformHandler.openScene(scene);*/
  }

  setAuditoriumMode = () =>{

  }

  joinPresentation = () => {
    //platformHandler.closeCurrentSession();
    this.changeScene('Role');
  }

  changeScene = (scene) => {
    this.handleDrawerClose();
    platformHandler.openScene(scene);
  }

  signOut = () => {
    this.handleDrawerClose();
    //platformHandler.closeCurrentSession();
    flipwitFirebaseConnector.signOut();

    if(platformHandler.isElectron) {
      platformHandler.openScene("Login");
    }
    else {
      platformHandler.openScene("Role");
    }
  }
  
  handleSubMenuItemCheck = name => event => {
    console.log('Check ',name,event.target,this)        
  
    //Algunos menus deben hacer algo adicional
    switch(name) {
      case "showConnectionHelp": 
                              //this.props.dispatch( setPresentationModeConfig( "showHotPlugin", {activated:true, pluginName: 'connection',pluginView: 'viewer'}) );
                              platformHandler.activateHotPlugin({activated:true,pluginName:'connection',pluginView:'viewer','userView':'user'});
                              this.handleSubMenuClose();
                              return;
      case "showDrawTools":   
      case "showLaserPointer":   
                              platformHandler.sendCommandToPresentationModeScreen( {command: name} );
                              break; 

      case "countRestart":  platformHandler.restartClock();
                            this.handleSubMenuClose();
                            return;

      case "showQuestions":   
                              platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );
                              //this.props.dispatch( setPresentationModeConfig( "showHotPlugin", {activated:true, pluginName: 'connection',pluginView: 'viewer'}) );
                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'crowdquestions',
                                pluginView:'exhibitor',
                                userView:'viewer',
                                showFullScreenInUser:false,
                                whiteBackground:false});
                              this.handleSubMenuClose();
                              return;

      case "showQuickSurvey": platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );

                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'survey',
                                pluginView:'exhibitor',
                                userView:'user',
                                showFullScreenInUser:true,
                                pluginInfo:{
                                  idToglea: "5949906682a9426826bff281",
                                  url: "https://app.flipwit.com/plugins/survey",
                                  slideIndex: 'hot' ,
                                  titleToglea: '',
                                  infoToglea: {
                                    "answers" : [
                                      "SI",
                                      "NO"
                                    ],
                                    "showResultsWhenClosed" : true,
                                    "correctAnswer" : -1
                                  },
                                }
                              });
                              return;

      case "showQuickWordCloud": platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );

                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'wordcloud',
                                //pluginView:'exhibitor',
                                pluginView:'viewer',
                                userView:'user',
                                showFullScreenInUser:true,
                                pluginInfo:{
                                  idToglea: "5cc4a3f08d08cb06104ae5ca_"+ new Date().getTime(),
                                  url: "https://app.flipwit.com/plugins/wordcloud",
                                  slideIndex: 'hot' ,
                                  titleToglea: 'Envia un mensaje al expositor',
                                  infoToglea: {
                                    "showResultsWhenClosed" : true,    
                                    "allowMultipleMessages" : true,                                                                    
                                  },
                                }
                              });

                              this.handleSubMenuClose();
                              return;

        case "showArquetipoTest": platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );

                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'arquetipoTest',
                                //pluginView:'exhibitor',
                                pluginView:'viewer',
                                userView:'user',
                                showFullScreenInUser:true,
                                pluginInfo:{
                                  idToglea: "5d4619876de73f09a0408ec3",
                                  url: "https://app.flipwit.com/plugins/arquetipoTest",
                                  slideIndex: 'hot' ,
                                  titleToglea: '',
                                  infoToglea: {"allowMultipleMessages" : false},
                                }
                              });

                              this.handleSubMenuClose();
                              return;

        case "showTipoAprendizajeTest": platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );

                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'tipoAprendizajeTest',
                                //pluginView:'exhibitor',
                                pluginView:'viewer',
                                userView:'user',
                                showFullScreenInUser:true,
                                pluginInfo:{
                                  idToglea: "5d50c2481ef154322046d315",
                                  url: "https://app.flipwit.com/plugins/tipoAprendizajeTest",
                                  slideIndex: 'hot' ,
                                  titleToglea: '',
                                  infoToglea: {"allowMultipleMessages" : false},
                                }
                              });

                              this.handleSubMenuClose();
                              return;

        case "showSenaTest": platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );

                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'senaTest',
                                //pluginView:'exhibitor',
                                pluginView:'viewer',
                                userView:'user',
                                showFullScreenInUser:true,
                                pluginInfo:{
                                  idToglea: "5d4f8cd3e492d135300c4943",
                                  url: "https://app.flipwit.com/plugins/senaTest",
                                  slideIndex: 'hot' ,
                                  titleToglea: '',
                                  infoToglea: {"allowMultipleMessages" : false},
                                }
                              });

                              this.handleSubMenuClose();
                              return;

        case "showIncubarVotes": platformHandler.sendCommandToPresentationModeScreen( {command: "showHotPlugin"} );

                              platformHandler.activateHotPlugin({activated:true,
                                pluginName:'incubarVotes',
                                //pluginView:'exhibitor',
                                pluginView:'viewer',
                                userView:'user',
                                showFullScreenInUser:true,
                                pluginInfo:{
                                  idToglea: "5d5ab2524b1c051c7459e08a",
                                  url: "https://app.flipwit.com/plugins/incubarVotes",
                                  slideIndex: 'hot' ,
                                  titleToglea: '',
                                  infoToglea: {
                                    "allowMultipleMessages" : false,
                                    textoInicial: `<div style='width: 100%; display: flex; flex-direction: column; align-items: center; max-width: 400px;'>
                                                  <img src='https://www.flipwit.com/dist/imgs/incubar/logonegro.png' style='width: 80%;' />
                                                  <img src='https://www.flipwit.com/dist/imgs/incubar/incubar.png' style='width: 50%; margin: 20px;' />
                                                  <strong style='font-size: 2em; margin-bottom: 20px; width: 100%; padding: 10px; background-color: lightgray;'>Bienvenido a nuestro concurso</strong>                            
                                                  <img src='https://www.flipwit.com/dist/imgs/incubar/aliados.png' style='width: 100%;' />
                                                  </div>`,
                                    data:  [
                                            { id:0,
                                              type:'open',
                                              isValidation:true,
                                              labelValidation: 'Código',
                                              question: 'Ingresa tu código para votar',
                                              textoBoton: 'INGRESAR',                                            
                                            },
                                            { id:1,
                                              type:'multiple',
                                              maxSelection:5,//La cantidad maxima que puede seleccionar
                                              exactSelection:true,//Solo se da por respondida si tiene seleccionada esa cantidad
                                              question: '¿Escoge las 5 empresas de DESCUBRIMIENTO a las cuales daras tus votos?',
                                              textoBoton: 'Siguientes empresas',
                                              options: [
                                                      {texto:'América Latina',img:''},
                                                      {texto:'Apis Vita',img:''},
                                                      {texto:'Bioplantarte',img:''},
                                                      {texto:'Brunett Beachwear',img:''},
                                                      {texto:'Frutishake',img:''},
                                                      {texto:'Kiru',img:''},
                                                      {texto:'Konciencia',img:''},
                                                      {texto:'Maracumbé',img:''},
                                                      {texto:'Mr. Jack Music',img:''},
                                                      {texto:'Nephula',img:''},
                                                      {texto:'Neurobica',img:''},
                                                      {texto:'Perra Básica',img:''},
                                                      {texto:'Pleglex',img:''},
                                                      {texto:'Sulata Cerveza Artesanal',img:''},
                                                      {texto:'Trail Hunters',img:''}
                                                    ]
                                            },
                                            { id:2,
                                              type:'multiple',
                                              maxSelection:3,
                                              exactSelection:true,
                                              question: '¿Escoge las 3 empresas de POTENCIACIÓN a las cuales daras tus votos?',
                                              textoBoton: 'Finalizar',
                                              options: [
                                                      {texto:'Cienda',img:''},
                                                      {texto:'El Nieto',img:''},
                                                      {texto:'Encantados',img:''},
                                                      {texto:'Happy Home',img:''},
                                                      {texto:'La Tienda Industrial',img:''},
                                                      {texto:'Monkey D',img:''},
                                                      {texto:'So Dope',img:''},
                                                      {texto:'Trámite Fácil ',img:''},
                                                      {texto:'Zend Entertainment',img:''}
                                                    ]
                                            }
                                          ]
                                  },
                                }
                              });

                              this.handleSubMenuClose();
                              return;

      default:
    }
    
    console.log('Pone ',name,'en',!this.props.configPresentationMode[name])
    this.props.dispatch( setPresentationModeConfig( name, !this.props.configPresentationMode[name]));
    this.handleSubMenuClose();
  };

  render() {
    const { classes } = this.props;
    const { open,subMenu } = this.state;
    const openSubMenu = Boolean(subMenu);

    let itemAuditorium = null; 
    /*if( platformHandler.isElectron ){
       itemAuditorium = this.menuAuditorium();
    }*/
    
    let itemMenuChangePresentation = null;
    try {
      //console.log('CHANGE con ' ,this.context.store.getState().containers.appReducer.currentData.slideName)
      if(this.context.store.getState().containers.appReducer.currentData.slideName!=="" && !platformHandler.blockExhibitForElectron()) {
        itemMenuChangePresentation = this.menuChangePresentation()
      }
    } catch(e){};

    let itemMenuJoinPresentation = null;
    try {
      //Solo se puede unir en pantallas que no sean las de Role, ya que realmente el menu de unirse a presentacion
      //lo que hacer es ir a la de Role, ademas no permite ir a la de Role si estoy en electron
      if( platformHandler.currentScene !== "Role" && !platformHandler.blockExhibitForElectron()){
        itemMenuJoinPresentation = this.menuJoinPresentation()
      }
    } catch(e){};

    let itemMenuLogOut = null;
    try {
        let objUser = userHandler.getCurrentUser();
        //Si si se tiene alguna informacion de usuario es porque esta logueado
        if(objUser && Object.keys(objUser).length>0) {
          itemMenuLogOut = this.menuLogOut();          
        }
    } catch(e){};
    

    console.log('tiene en estado ', this.context.store.getState().containers.appReducer.showMenu)
    //Si se debe mostrar el menu, el icono son las tres barras, si no es una flecha atras
    let iconMenu = this.context.store.getState().containers.appReducer.showMenu?<MenuIcon />:<ArrowBackIcon />;

    const drawer = (
      <Drawer
        /*variant="persistent"*/
        onClose={this.handleDrawerClose}
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <Typography className={classes.userLabel}>{userHandler.getCurrentUser().displayName}</Typography>
          <IconButton onClick={this.handleDrawerClose} className={classes.menuCloseIcon}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          {itemMenuJoinPresentation}          
          {this.menuLanguage(classes)}
          {itemMenuLogOut}
          {itemMenuChangePresentation}
          {itemAuditorium}
          {this.closeMenu()}
        </List>
      </Drawer>
    );

    //Si debe mostrar o no el subMenu de la derecha
    let shouldShowSubMenu = this.context.store.getState().containers.appReducer.configSubMenu.opened;
    let subMenus = this.context.store.getState().containers.appReducer.configSubMenu.subMenus;

    let configMenu = this.context.store.getState().containers.appReducer.configPresentationMode;    
    let amountQuestions = configMenu.questionsAmountForPresentation;

return (
      <div className={classes.root}>
        {drawer}
        <div className={classes.appFrame}>
          <AppBar
            className={classNames(classes.appBar, {
              [classes.appBarShift]: open,
              [classes[`appBarShift-$left`]]: open,
            })}
          >
            <Toolbar disableGutters={!open} className={classes.toolBar}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.clickOnDrawerIcon}                
                className={classNames(classes.menuButton, open && classes.hide)}
                classes={{label:classes.iconMenuBar}}
              >
                {iconMenu}
              </IconButton>
              <Typography className={classes.title} variant="h6" color="inherit" noWrap>
                {this.context.store.getState().containers.appReducer.titleAppBar}
              </Typography>
            </Toolbar>
            
            {/*Todo el menu de la derecha*/}
            {shouldShowSubMenu && <React.Fragment>
              <div id="subMenuBot" className={classes.divSubMenu} >
              <IconButton
                aria-label="More"
                aria-haspopup="true"
                color="inherit"                
                onClick={this.clickOnSubMenuIcon}                
                className={classNames(classes.subMenuButton)}
                classes={{label:classes.iconSubMenuBar}}
              >              
                {amountQuestions>0 && <Badge classes={{badge: classes.badgeVotesSubMenu}} color="secondary" badgeContent={amountQuestions}>
                  <MoreVertIcon />
                </Badge>}
                {amountQuestions==0 && <MoreVertIcon />}
              </IconButton>
              </div>
              <Menu
                id="long-menu"
                anchorEl={subMenu}
                open={openSubMenu}
                onClose={this.handleSubMenuClose}
                PaperProps={{
                  style: {
                    width: 300,
                  },
                }}
              >
                {/*Botón de volver*/}
                <IconButton
                    aria-label="More"
                    aria-haspopup="true"
                    color="inherit"                
                    onClick={this.handleSubMenuClose}  
                    className={classes.subMenuBackButton}
                  >
                  <ArrowBackIcon />
                </IconButton>

                {subMenus.map((item, i) => {
                  return this.getSecondMenuItem(item);
                })}                
                                       
              </Menu>
            </React.Fragment>}
          </AppBar>              
        </div>
      </div>      
    );
  }
  
  getSecondMenuItem = (type) => {

    const { classes, usersCount, configPresentationMode } = this.props;
    
    let configMenu = this.context.store.getState().containers.appReducer.configPresentationMode;

    switch(type) {
      /*Cantidad de usuarios*/
      case "userCount": return (<MenuItem key={"topbar"}>
                          <GroupIcon className={classes.subMenuIcon} /> {languageManager.getLangWord("USERS")}: {usersCount} 
                        </MenuItem>);

      case "showConnectionHelp": return (<MenuItem key={"showConnectionHelp"} onClick={this.handleSubMenuItemCheck('showConnectionHelp')} >
                                  {languageManager.getLangWord("SHOW_CONNECTION_HELP")}
                                </MenuItem>)

      case "showQuestions":   let amountQuestions = configMenu.questionsAmountForPresentation;

                              return (<MenuItem key={"showQuestions"} onClick={this.handleSubMenuItemCheck('showQuestions')} >
                                      {amountQuestions>0 && <Badge classes={{badge: classes.badgeVotes}} color="secondary" badgeContent={amountQuestions}>
                                          {languageManager.getLangWord("SHOW_AUDIENCE_QUESTIONS")} 
                                        </Badge>}
                                      {amountQuestions===0 && languageManager.getLangWord("SHOW_AUDIENCE_QUESTIONS")}
                                    </MenuItem>)

      case "showQuickSurvey":   return (<MenuItem key={"showQuickSurvey"} onClick={this.handleSubMenuItemCheck('showQuickSurvey')} >
                                  {"Pregunta rapida"}
                                </MenuItem>)

      case "showQuickWordCloud":   return (<MenuItem key={"showQuickWordCloud"} onClick={this.handleSubMenuItemCheck('showQuickWordCloud')} >
                                  {"Nube de palabras"}
                                </MenuItem>)

      case "showArquetipoTest":   return (<MenuItem key={"showArquetipoTest"} onClick={this.handleSubMenuItemCheck('showArquetipoTest')} >
                                  {"Test de Arquetipo"}
                                </MenuItem>)
      
      case "showTipoAprendizajeTest":   return (<MenuItem key={"showTipoAprendizajeTest"} onClick={this.handleSubMenuItemCheck('showTipoAprendizajeTest')} >
                                  {"Test de Tipos de Aprendizaje"}
                                </MenuItem>)

      case "showSenaTest":   return (<MenuItem key={"showSenaTest"} onClick={this.handleSubMenuItemCheck('showSenaTest')} >
                                  {"Calificación de la capacitación"}
                                </MenuItem>)

      case "showIncubarVotes":   return (<MenuItem key={"showIncubarVotes"} onClick={this.handleSubMenuItemCheck('showIncubarVotes')} >
                                  {"Activar Votación Curso Concurso"}
                                </MenuItem>)


      /*Check de si mostrar o no el preview*/
      case "showPreview": return (<MenuItem key={"showPreview"}
                            className={classes.menuItemCheck}
                            onClick={this.handleSubMenuItemCheck('showPreview')}>
                            {languageManager.getLangWord("SHOW_PREVIEW")}
                            <Checkbox checked={configPresentationMode.showPreview} onChange={this.handleSubMenuItemCheck('showPreview')} value="show_preview" />
                          </MenuItem>)

      /*Check de si mostrar o no el preview*/
      case "showUrlBar": return (<MenuItem key={"showUrlBar"}
                            className={classes.menuItemCheck}
                            onClick={this.handleSubMenuItemCheck('showUrlBar')}>
                            {languageManager.getLangWord("SHOW_URL_BAR")}
                            <Checkbox checked={configPresentationMode.showUrlBar} onChange={this.handleSubMenuItemCheck('showUrlBar')} value="show_url_bar" />
                          </MenuItem>)


      /*Mostrar herramientas de dibujo*/
      case "showDrawTools": return (<MenuItem key={"showDrawTools"} 
                              onClick={this.handleSubMenuItemCheck('showDrawTools')} disabled={!configMenu.showMenuTools} >
                              {languageManager.getLangWord("ACTIVATE_DRAW_TOOL")}
                            </MenuItem>)

      /*Mostrar herramienta de puntero laser*/
      case "showLaserPointer": return (<MenuItem key={"showLaserPointer"} 
                                onClick={this.handleSubMenuItemCheck('showLaserPointer')} disabled={!configMenu.showMenuTools} >
                                {languageManager.getLangWord("ACTIVATE_LASER_TOOL")}
                              </MenuItem>)

      /*Reiniciar reloj*/
      case "countRestart": return (<MenuItem key={"countRestart"} onClick={this.handleSubMenuItemCheck('countRestart')}>
                              {languageManager.getLangWord("COUNT_RESTART")}
                            </MenuItem>)

      case "closePresentation": return (<MenuItem key={"closePresentation"} onClick={this.changePresentation}>
                                  {languageManager.getLangWord("NAV_MENU.CHANGE_PRESENTATION")}
                                </MenuItem>)

      default:  return null;
    }
  }

  menuAuditorium = () => (
    <ListItem button onClick={this.setAuditoriumMode}>
        <ListItemIcon>
          <InputIcon />
        </ListItemIcon>
        <ListItemText primary={languageManager.getLangWord("NAV_MENU.AUDITORIUM_MODE")} />
      </ListItem>
  )

  menuChangePresentation = () => (
    <ListItem button onClick={this.changePresentation}>
        <ListItemIcon>
          <CloseIcon />
        </ListItemIcon>
        <ListItemText primary={languageManager.getLangWord("NAV_MENU.CHANGE_PRESENTATION")} />
      </ListItem>
  )

  menuJoinPresentation = () => (
    <ListItem button onClick={this.joinPresentation}>
        <ListItemIcon>
          <InputIcon />
        </ListItemIcon>
        <ListItemText primary={languageManager.getLangWord("NAV_MENU.JOIN_PRESENTATION")} />
      </ListItem>
  )

  renderLanguage = (obj, i) => {
    return ( <FormControlLabel key={i} value={obj.value} control={<Radio />} label={obj.title} /> )
  }

  menuLanguage = (classes) => (
    <div>
    <ListItem button onClick={this.handleClick}>
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>
        <ListItemText primary={languageManager.getLangWord("NAV_MENU.LANGUAGE")} />
        <ExpandMore className={(classes.arrowMenu) + " " + (this.state.openLang?classes.rotate90:null)} />
    </ListItem>
    <Collapse in={this.state.openLang} timeout="auto" unmountOnExit>
      <RadioGroup
          aria-label="Language"
          name="language"            
          value={this.state.selectedLang}
          onChange={this.handleLangChange}
      >
        {/*PINTA LOS LENGUAJES DISPONIBLES, PARA GENERAR ESTO:
          <FormControlLabel value="es" control={<Radio />} label="Español" />
          <FormControlLabel value="en" control={<Radio />} label="Ingles" />
        */}
        { LANGUAGES.map( (obj, i) => {
            return ( <FormControlLabel key={i} value={obj.value} control={<Radio />} label={obj.title} /> )
        } ) }        
      </RadioGroup> 
    </Collapse>
    </div>
  )

  menuLogOut = () => (
    <ListItem button onClick={this.signOut}>
        <ListItemIcon>
          <PowerSettingsNewIcon />
        </ListItemIcon>
        <ListItemText primary={languageManager.getLangWord("NAV_MENU.LOGOUT")} />
      </ListItem>
  )

  closeMenu = () => (
    <ListItem button onClick={this.handleDrawerClose}>
        <ListItemIcon>
          <ChevronLeftIcon />
        </ListItemIcon>
        <ListItemText primary={languageManager.getLangWord("NAV_MENU.CLOSEMENU")} />
      </ListItem>
  )
}

MenuFlipwit.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};


MenuFlipwit.contextTypes = {
  store: PropTypes.object,
};


const mapStateToProps = state => {  
  return {
    showMenu: state.containers.appReducer.showMenu, 
    titleAppBar: state.containers.appReducer.titleAppBar, 
    configPresentationMode: state.containers.appReducer.configPresentationMode,   
    usersCount: state.containers.appReducer.currentData.usersCount,
  }
};

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(MenuFlipwit));


// WEBPACK FOOTER //
// ./src/containers/components/MenuFlipwit.js